function Upcoming({ animal }) {
  return (
    <div className="shadow-md rounded-md p-8 bg-gray-50">
      <div className="font-medium text-lg mb-4">Upcoming...</div>
      <div className="flex gap-2">
        {[0, 1, 2, 3, 4].map((item) => (
          <div className="rounded-md shadow-sm bg-white p-4 h-48"> {item}</div>
        ))}
      </div>
    </div>
  );
}

export default Upcoming;
